import React from 'react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_TOTAL, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="bg-navy" data-id="element-56" data-mp="c70xva6rjfok">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-57" data-mp="c4fuggqtgrop">
        <h2 id="cierre" className="font-display text-[1.6rem] font-extrabold uppercase leading-none tracking-tight text-sol sm:text-4xl" data-id="element-58" data-mp="83m7pqp41ixe">
          Una última oportunidad
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-white/90" data-id="element-59" data-mp="h3rdjweno99g">
          Podés seguir buscando videos, aplicaciones y traducciones sin saber
          qué frases necesitás aprender primero para viajar. O podés comenzar
          hoy a construir una base de inglés práctico siguiendo una ruta
          organizada desde cero.
        </p>
        <p className="mx-auto mt-1.5 max-w-xl font-sub text-sm font-semibold leading-snug text-white" data-id="element-60" data-mp="zx4rqpu5g12d">
          No necesitás hablar inglés perfecto para empezar.{' '}
          <span className="text-sol" data-id="element-61" data-mp="2h3ri8mmvdngt">Necesitás dar el primer paso.</span>
        </p>

        <Reveal className="mt-3 rounded-2xl border-4 border-dashed border-sol bg-white p-3 text-navy" data-id="element-62" data-mp="2h5knpylqy1n8">
          <p className="font-sub text-sm font-bold uppercase leading-tight text-navy" data-id="element-63" data-mp="2m570k6xnxfvi">
            {PRODUCT_NAME}
          </p>
          <p className="mt-1 inline-block rounded-md bg-sol px-2 py-0.5 font-display text-2xl font-black uppercase leading-tight text-navy" data-id="element-64" data-mp="2v428pok9p01g">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1 text-xs font-semibold text-navy/80 sm:text-sm" data-id="element-65" data-mp="34tlscwft0xxd">
            Valor de los bonos:{' '}
            <span className="line-through decoration-coral decoration-2" data-id="element-66" data-mp="39sygdkiewb1j">{BONUS_TOTAL}</span>
          </p>
          <p className="mx-auto mt-1.5 w-fit rounded-xl border-2 border-navy bg-coral px-3 py-1 font-display text-5xl font-black leading-none text-white sm:text-6xl" data-id="element-67" data-mp="3esb03wdzl1zw">
            <span className="text-2xl sm:text-3xl" data-id="element-68" data-mp="1joczkidfp7yn">Hoy:</span> {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-69" data-mp="1jm8sxso5huuo">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 text-xs font-semibold text-navy/80" data-id="element-70" data-mp="1sh6svjppu7vi">
            Acceso Inmediato • Entrega Digital • Garantía de 7 Días
          </p>
        </Reveal>
      </div>
    </section>;
}